const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://127.0.0.1:8787';

export type RankThresholds = {
  rank: string;
  minScore: number;
};

async function throwIfNotOk(response: Response) {
  if (response.ok) return;
  const payload = await response.json().catch(() => ({}));
  const message = typeof payload.message === 'string' ? payload.message : 'API request failed';
  throw new Error(message);
}

export async function fetchRankMaster() {
  const response = await fetch(`${apiBaseUrl}/api/admin/rank-master`);
  await throwIfNotOk(response);
  return (await response.json()) as RankThresholds[];
}

export async function saveRankMaster(input: RankThresholds[]) {
  const response = await fetch(`${apiBaseUrl}/api/admin/rank-master`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ items: input }),
  });
  await throwIfNotOk(response);
  const payload = (await response.json()) as { result: { updated: boolean } };
  return payload.result;
}
